import React from 'react';
import { Dialog, FormGrid, JsonEditorTextarea, TabPanel, TabsHeader, useTabsState } from '../../primitives';
import { BlocksConfigurationData } from './useEditBlocksConfiguration';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';

interface Props {
  data: BlocksConfigurationData;
}

export const BlocksConfigurationDialog = (props: Props) => {
  const { data } = props;

  const tabs = useTabsState(
    [
      ["cfb",<FormattedMessage id="powerdoc.plugins.custom_fields_block.title" />],
      ["ct",<FormattedMessage id="powerdoc.plugins.configurable_table_block.title" />],
    ]
  )

  if(!data.dialog.isOpen) {
    return null;
  }

  return (
    <Dialog
      dialogTitle={<FormattedMessage id="cms.blocks_configuration.title" />}
      fullWidth
      maxWidth="lg"
      noFullscreen
      {...data.dialog}
      actions={<>
        <Button color="primary" variant="contained" onClick={() => data.save()}><FormattedMessage id="common.save" /></Button>
      </>}
      >
      <TabsHeader
        state={tabs}
        noMargin
        scrollable
        />
      
      <TabPanel state={tabs.forTab("cfb")}>
        {!!data.item &&
          <FormGrid columns="1fr" noMargin>
            <JsonEditorTextarea
              value={data.item?.custom_fields_block_config}
              onChange={e => data.update({ custom_fields_block_config: e.target.value })}
              />
          </FormGrid>}
      </TabPanel>

      <TabPanel state={tabs.forTab("ct")}>
        {!!data.item &&
          <FormGrid columns="1fr" noMargin>
            <JsonEditorTextarea
              value={data.item?.configurable_table_block_config}
              onChange={e => data.update({ configurable_table_block_config: e.target.value })}
              />
          </FormGrid>}
      </TabPanel>
    </Dialog>
  );
}
